import { ReactNode } from 'react';

import { LeftBlock } from '@/app/shared/svgComponents/LeftBlock';
import { RightBlock } from '@/app/shared/svgComponents/RightBlock';

interface VaultsPageContainerProps {
  tabs: ReactNode;
  children: ReactNode;
}

const VaultsPageContainer = ({ tabs, children }: VaultsPageContainerProps) => {
  return (
    <div className='border-decoration-stroke flex min-h-[calc(100vh-230px)] flex-col md:min-h-[calc(100vh-138px)] xl:mx-[23px] xl:border-x'>
      <div className='grid min-h-0 flex-1 grid-cols-1 grid-rows-[260px_auto_auto_100px_1fr] xl:grid-cols-[1fr_minmax(0,1244px)_1fr]'>
        <div className='border-decoration-stroke hidden border-b xl:block min-[1300px]:border-r' />
        <div className='border-decoration-stroke flex h-[260px] flex-col justify-end gap-3 border-b px-5 pb-[42px] min-[1300px]:px-10'>
          <h1 className='text-2xl font-normal text-gray-50 md:text-[30px]'>Vaults</h1>
          <p className='max-w-[594px] text-base leading-6 text-gray-400'>
            Yield strategies split by risk. Junior for the higher yield, senior for a loss buffer.
          </p>
        </div>
        <div className='border-decoration-stroke hidden border-b xl:block min-[1300px]:border-l' />

        <div className='border-decoration-stroke hidden h-2.5 border-b xl:block min-[1300px]:border-r' />
        <div className='border-decoration-stroke h-2.5 border-b' />
        <div className='border-decoration-stroke hidden h-2.5 border-b xl:block min-[1300px]:border-l' />

        <div className='border-decoration-stroke hidden h-2.5 border-b xl:block min-[1300px]:border-r' />
        <div className='border-decoration-stroke h-2.5 border-b' />
        <div className='border-decoration-stroke hidden h-2.5 border-b xl:block min-[1300px]:border-l' />

        <div className='border-decoration-stroke hidden h-[100px] border-b xl:block min-[1300px]:border-r'>
          <div
            className='hidden h-full w-full opacity-30 min-[1300px]:block'
            style={{ background: 'linear-gradient(270deg, var(--decoration-stroke) 0%, var(--background) 100%)' }}
          />
        </div>
        <div className='border-decoration-stroke flex h-[100px] min-h-[100px] max-h-[100px] items-stretch border-b px-5 min-[1300px]:px-10'>{tabs}</div>
        <div className='border-decoration-stroke hidden h-[100px] border-b xl:block min-[1300px]:border-l'>
          <div
            className='hidden h-full w-full opacity-30 min-[1300px]:block'
            style={{ background: 'linear-gradient(90deg, var(--decoration-stroke) 0%, var(--background) 100%)' }}
          />
        </div>

        <div className='border-decoration-stroke relative hidden xl:block min-[1300px]:border-r'>
          <LeftBlock
            className='pointer-events-none absolute right-0 bottom-0 hidden h-[359px] w-full min-[1560px]:block'
            strokeColor='var(--decoration-stroke)'
            fillColor='var(--decoration-fill)'
          />
        </div>
        <div className='flex h-full min-h-0 w-full flex-col px-5 py-8 md:py-10 min-[1300px]:px-10'>{children}</div>
        <div className='border-decoration-stroke relative hidden xl:block min-[1300px]:border-l'>
          <RightBlock
            className='pointer-events-none absolute bottom-0 left-0 hidden h-[359px] w-full min-[1560px]:block'
            strokeColor='var(--decoration-stroke)'
            fillColor='var(--decoration-fill)'
          />
        </div>
      </div>
    </div>
  );
};

export default VaultsPageContainer;
